module.exports = __webpack_public_path__ + "img/ico_daren.73142fb4.png";